export function timeAgo(iso, lang) {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  const units = [
    [31536000, "an", "y"],
    [2592000, "mois", "mo"],
    [86400, "j", "d"],
    [3600, "h", "h"],
    [60, "min", "m"],
  ];
  for (const [sec, fr, en] of units) {
    if (s >= sec) {
      const v = Math.floor(s / sec);
      return lang === "fr" ? `il y a ${v} ${fr}` : `${v}${en} ago`;
    }
  }
  return lang === "fr" ? "à l'instant" : "just now";
}
